import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../../services/api";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logoSmall from "../../comum/assets/arbor.png";
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';
import "./novasenha.css";

function EsqueciSenha() {
  const navigate = useNavigate();
  const [chapa, setChapa] = useState("");
  const [usuario, setUsuario] = useState(null);
  const [etapa, setEtapa] = useState(1);
  
  // Inputs do usuário
  const [cpfDigitado, setCpfDigitado] = useState("");
  const [nascimentoDigitado, setNascimentoDigitado] = useState("");
  const [emailDigitado, setEmailDigitado] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const cpfRef = useRef(null);

  // Funções de máscara visual (Ex: 055.***.***-50 e fa***@flo***.com)
  const formatarCPFParcial = (cpf) => {
    if (!cpf || cpf.length < 11) return "***.***.***-**";
    return `${cpf.substring(0, 3)}.***.***-${cpf.substring(9, 11)}`;
  };

  const formatarEmailParcial = (email) => {
    if (!email || !email.includes("@")) return "*****@*****";
    const [user, domain] = email.split("@");
    return `${user.substring(0, 3)}*****@${domain.substring(0, 4)}*****`;
  };

  const buscarPorChapa = async () => {
    if (!chapa) return Swal.fire("Erro", "Informe a matrícula", "error");
    try {
      const { data } = await api.get(`/usuario/dados/${chapa}`);
      if (data && data.length > 0) {
        setUsuario(data[0]);
        setEtapa(2);
      } else {
        Swal.fire("Erro", "Matrícula não encontrada", "error");
      }
    } catch (error) {
      Swal.fire("Erro", "Falha ao buscar dados", "error");
    }
  };

  const validarDados = () => {
    const cpfLimpo = cpfDigitado.replace(/\D/g, "");
    const nascFormatado = new Date(usuario.dtnascimento).toISOString().substring(0, 10);

    if (cpfLimpo !== usuario.cpf) {
      return Swal.fire("Erro", "CPF não confere", "error");
    }
    if (nascimentoDigitado !== nascFormatado) {
      return Swal.fire("Erro", "Data de nascimento não confere", "error");
    }
    if (emailDigitado.trim().toLowerCase() !== usuario.email.trim().toLowerCase()) {
      return Swal.fire("Erro", "E-mail não confere", "error");
    }

    setEtapa(3);
  };

  const salvarNovaSenha = async () => {
    try {
      const response = await api.post(`/usuario/${usuario.chapa}`, { senha: novaSenha });
      if (response.status === 201 || response.status === 200) {
        Swal.fire("Sucesso", "Senha alterada com sucesso!", "success");
        navigate("/arbor/login");
      }
    } catch (error) {
      Swal.fire("Erro", "Não foi possível alterar a senha", "error");
    }
  };

  return (
    <div className="d-flex flex-column vh-100 overflow-hidden">
      <Menu modulo="ALTERAR SENHA" />
      
      <div className="form-container-novasenha">
        <div className="card-novasenha text-center">
          <img className="img-login-novasenha" src={logoSmall} alt="Arbor Web" />
          <h1 className="title-novasenha">Recuperar Acesso</h1>

          {etapa === 1 && (
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-floating mb-3">
                <input 
                  type="text" 
                  id="floatingChapa"
                  className="form-control" 
                  placeholder="Matrícula"
                  value={chapa} 
                  onChange={(e) => setChapa(e.target.value)} 
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      buscarPorChapa();
                    }
                  }}
                />
                <label htmlFor="floatingChapa">Informe sua Matrícula</label>
              </div>

              <button 
                type="button" 
                className="w-100 btn btn-arbor-primary" 
                onClick={buscarPorChapa}
              >
                Continuar
              </button>
            </form>
          )}

          {etapa === 2 && (
            <form onSubmit={(e) => e.preventDefault()}>
              <p className="text-muted small mb-3">Confirme os dados cadastrados para sua segurança</p>
              
              <div className="form-floating mb-2">
                <InputMask 
                  mask="999.999.999-99" 
                  id="floatingCpf"
                  className="form-control" 
                  placeholder="CPF"
                  onChange={(e) => setCpfDigitado(e.target.value)} 
                />
                <label htmlFor="floatingCpf">CPF (Inicia com {formatarCPFParcial(usuario?.cpf)})</label>
              </div>

              <div className="form-floating mb-2">
                <input 
                  type="date" 
                  id="floatingNasc"
                  className="form-control" 
                  placeholder="Data de Nascimento"
                  onChange={(e) => setNascimentoDigitado(e.target.value)} 
                />
                <label htmlFor="floatingNasc">Data de Nascimento</label>
              </div>

              <div className="form-floating mb-3">
                <input 
                  type="email" 
                  id="floatingEmail"
                  className="form-control" 
                  placeholder="E-mail"
                  onChange={(e) => setEmailDigitado(e.target.value)} 
                />
                <label htmlFor="floatingEmail">E-mail (Dica: {formatarEmailParcial(usuario?.email)})</label>
              </div>

              <button 
                type="button" 
                className="w-100 btn btn-arbor-primary" 
                onClick={validarDados}
              >
                Validar Dados
              </button>
            </form>
          )}

          {etapa === 3 && (
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-floating mb-3">
                <input 
                  type={showPassword ? "text" : "password"} 
                  id="floatingNovaSenha"
                  className="form-control" 
                  placeholder="Nova Senha"
                  onChange={(e) => setNovaSenha(e.target.value)} 
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && novaSenha.length >= 6) {
                      e.preventDefault();
                      salvarNovaSenha();
                    }
                  }}
                />
                <label htmlFor="floatingNovaSenha">Nova Senha (Mínimo 6 caracteres)</label>
                <button
                  type="button"
                  className="btn-eye-toggle-novasenha"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex="-1"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>

              <button 
                type="button" 
                className="w-100 btn btn-arbor-primary" 
                onClick={salvarNovaSenha} 
                disabled={novaSenha.length < 6}
              >
                Atualizar Senha
              </button>
            </form>
          )}

          <div className="login-links-novasenha">
            <Link to="/arbor/login" className="link-arbor">
              Voltar para o Login
            </Link>
          </div>

          <p className="text-copyright-novasenha text-center">
            &copy; Desenvolvido por F2 Enterprise
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default EsqueciSenha;